import type {Module} from "vuex";
import type {RootState} from "@/store/types";
import {platform} from "@/api/platform";

import equipment from "./quiz/equipment";
import profile from "./quiz/profile";
import {retryRequest} from "@/helpers/request";

// Country of the partner's countries list
export type QuizCountry = Record<string, unknown>

export interface QuizState {
    countries: QuizCountry[]
}

const quiz: Module<QuizState, RootState> = {
    namespaced: true,
    state: {
        countries: []
    },
    getters: {
        countries: (state): QuizCountry[] => state.countries,
    },
    actions: {
        // Loads the countries once; later calls return the loaded list
        fetch(context): QuizCountry[] | Promise<QuizCountry[]> {

            if (context.state.countries && 0 < context.state.countries.length) {

                return context.state.countries
            }

            return retryRequest(() => platform.get<{results: QuizCountry[]}>("/api/v2/partner/countrieslist"))
                .then(response => context.state.countries = response.data.results);
        }
    },
    modules: {
        equipment,
        profile,
    }
}

export default quiz
